import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateUtcToLocal',
})
export class DateUtcToLocalPipe implements PipeTransform {
  transform(date: string, format: string, outputFormat = ''): any {
    const temp = moment.utc(date, format);
    return temp.local().format(outputFormat ? outputFormat : format);
  }
}
